import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { scroller } from "react-scroll";

import Hero from "../components/Hero";
import Features from "../components/Features";
import CTA from "../components/CTA";
import Contact from "../components/Contact";

export default function Homepage() {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollToContact) {
      // Scroll to contact section after page renders
      setTimeout(() => {
        scroller.scrollTo("contact-section", {
          smooth: true,
          offset: -60, // adjust according to navbar height
          duration: 600,
        });
      }, 100);
    }
  }, [location]);

  return (
    <div className="w-full min-h-screen bg-gray-950 text-white">
      <Hero />
      <Features />
      <CTA />
      <Contact />
    </div>
  );
}
